module.exports = {
  db30fe19588fd8c4: "YYYY 年",
  "8629fc47adf62a40": "MM 月",
  "5b6f28d3282af680": "切换语言",
  "9fcdcb3a067903d8": "中文",
  "9144ddc68d05d528": "Start time",
  "8b5d709462c8e71e": "End time",
  de50cdb3c301d44e: " To ",
  "11dc49914b8c56d2": "YYYY 年",
  "0e5ea5d9d98d17e4": "                  Generating",
  "95d22c733b3a558b": "No data has been exported yet!",
  "245883c80f181c4a": "Download",
  "4b3340f7872b411f": "Cancel",
  ceb0f1f17c8c088a: "Retry",
  "8a723a5ad03fbef7":
    "Visually present your data with a new perspective, reveal hidden story content behind each data stream",
  "79f45f61305a0694": "Data",
  "82adf873c2aef782": "Capture customer feedbacks from different channels, understand what customers say",
  cd613ea5c3daa178: "Text analysis",
  "2bcd2acb33ab9226": "Bring in-depth insights to unstructured data and empower value of data",
  "2c7ee80c60ede727": "Action record",
  "58f6db165d04ad25": "Accurately predict probability of customer churn and automatically track circulation",
  "0df7926026e8e4e3": "Tickets",
  ae1d807fd0454199: "Speech Analytics",
  "4a225c64927330be":
    "Quick warnings of customer complaints can effectively help you prevent from negative reviews, thereby enhancing customer satisfaction and repurchase willingness",
  "2bc8f2a83dcff037": "Setting",
  "16ffc39911362949":
    "Open highly customized modules, provide powerful visualization tools, seamlessly connect ai with bi",
  c5bda3e67870893b: "Voice analysis",
  ee34d8dc6f215415: "Vocust ai turns every guest phone call into indicators to improve customer experience",
  "5da3515674304897": "Text Analytics",
  a3c01440cba1fd06: "Data analysis of all-channel reviews, response system of one-stop reviews",
  f6e62f9642018cbb: "Main page",
  "65754b79e7c41c2e":
    "Overview of comprehensive situation, real-time analysis of key indicators, ai-assisted diagnosis of key points of problems",
  "1c4cb97f3f9338d2": "Experience Analytics",
  b52df67306a35e1e: "Use voice of customer as feedback channel to understand what happens in hotel every day",
  aa7e6c204c751cfa: "Sign out",
  daaaeb1b7b22b126: "Hint",
  "204ffab8a6e01870": "Confirm",
  "99c6de19eee99cbd": "I'm the title",
  d5001524a5b363be: "Customer service system",
  c95e288930c2d650: "Contact us",
  "2a0c41705beab1c4": "Enterprise settings",
  "03bc57fa724ffe80": "My Account",
  b1a35339ebce4e70: "Application Center",
  cc42c6e70c289f19: "Enterprise settings",
  b19febc08994f009: "My Account",
  b4bced00356095dc: "Sign out",
  c066ca9e9373f4d4: "Online consultation",
  "07c9d82ce42fdb94": "Contact us",
  dc1be1aee87ddbbf: "Add exclusive customer service",
  f3e283a3944775ff: "Answer your questions one-on-one",
  "55e274a683da9316": "Consultation telephone：400-869-2990",
  "1c8bd65646e50fff": "Back to today",
  b1b93a04399891da: "Please enter text content",
  ae761dce162dc46e: "倍数",
  "29adff17ec123b86": "排队中",
  "2b106e1cf0ecb720": "生成中",
  "720255ed1dcefd87": "                消息中心",
  "4672a61500412430": "System Selection",
  e6a250894a04db4c: "详情",
  "8bc1785cb7e61665": "数据明细，助力酒店集团一查到底，深度聚焦问题，提升集团管控能力",
  "8f25571b6140639f": "分析看板",
  c935c1d59ee52208: "灵活的数据分析看板，自由定制，满足集团/事业部多种数据分析需求",
  "80ca7ecf9313ef17": "市场分析",
  "803f12f69cd31b8c": "犀利洞察和预警市场变化，助力企业随机应变，取得先机",
  "877baf13a06ce174": "质量微循环",
  e1c9ff1d345d58c5: "用检查表加工作流的方式赋能门店的MOD、TQM检查。",
  "5e1466065999ca19": "单店操作管理",
  "37b469bf39d0fdd2": "门店/帐号维度的访问数据统计，帮助管理者及时洞察产品使用情况",
  f4c19062aa935c68: "客户管理",
  cd82b93f3e8f252b: "全渠道数据聚合的客户画像管理",
  c3525eb110db58aa: "更多",
  db956d943d09abdb: "立即免费体验",
  "28a2281262eeb577": "入住确认、续住确认、满意度回访开箱即用",
  "0ff4257c11825f37": "智能外呼",
  de6d10e5acd01f70: "Hello,",
  b25692821fba7ab1: "Return to old Nav",
  "77c1d7b636b40db9": "Are you sure to return to the old version of the navigation for use?",
  "5556ba0c8eacf558": "Use the new Nav",
  "022a3d7c171bb839": "Have you confirmed the use of the new version of navigation?"
}
